import { getBrowserFingerprint } from '../copied/fingerprint';
import { waitForIDs } from '../copied/getIds';
import isTestParam from '../copied/isTestParam';
import makeApi from './api';

export default async function fetchLiveChat({
  uuid,
  scenarioChange = false,
}: {
  uuid?: string;
  scenarioChange?: boolean;
}) {
  const { conditionId: condition, rxId } = await waitForIDs();
  const fingerprint = await getBrowserFingerprint();
  const testOnly = isTestParam();
  const urlParams = new URLSearchParams(window.location.search);
  const recoveryToken = urlParams.get('link_token') || '';

  window.ostro?.analytics?.addPersistentParams?.({ conditionUUID: condition, RxID: rxId });

  const api = makeApi();
  const payload: Record<string, unknown> = {
    condition,
    incoming_url: window.location.href,
    rx_user_uuid: rxId ? rxId : undefined,
    fingerprint,
    test_only: testOnly,
    scenarioChange,
  };

  if (recoveryToken) {
    payload.link_token = recoveryToken;
  }

  const response = await api.post(`/api/v1/web_chat/v3.0/help-center/${uuid}/live-chat/`, payload);

  return response.data;
}

export async function fetchConsentForm({ uuid, data }: { uuid: string; data: unknown }) {
  const api = makeApi();
  return await api.post(`/api/v1/web_chat/v3.0/help-center/${uuid}/live-chat/answer/`, data);
}

export async function sendFormAnswer<T>({ uuid, data }: { uuid?: string; data: unknown }) {
  const api = makeApi();
  return await api.post<T>(`/api/v1/web_chat/v3.0/help-center/${uuid}/live-chat/answer/`, data);
}

export async function sendFormDismiss({ uuid, data }: { uuid?: string; data: { form_ref_id: unknown } }) {
  const api = makeApi();

  return await api.post(`/api/v1/web_chat/v3.0/help-center/${uuid}/live-chat/dismiss/`, {
    form_ref_id: data?.form_ref_id,
  });
}
